// These are meta tags for the product and category pages.
// These should really all be moved into the database and retrieved via the Product Service.

/* eslint-disable max-len */
const seoTags = [
  {
    meta_description:
      'Browse our collection of cufflinks and studs to pair with your suit or tuxedo. Styles for your event, or wedding party.',
    page_title: 'Cufflinks and Studs | The Black Tux',
    url_path: '/collections/cufflinks-studs',
  },
  {
    meta_description:
      'Browse our collection of neckwear in all colors and styles, including ties and bowties. Top off the perfect look for your special event or wedding.',
    page_title: 'Neckwear | The Black Tux',
    url_path: '/collections/neckwear-2',
  },
  {
    meta_description:
      'Discover complete oufits designed by our expert stylists. Find the perfect outfit for your wedding, groomsmen, or event.',
    page_title: 'Complete Outfits | The Black Tux',
    url_path: '/collections/outfits',
  },
  {
    meta_description:
      'Shop our collection of modern and timeless dress shirts in classic and slim fits. Find the perfect tuxedo shirt for your wedding or event.',
    page_title: 'Dress Shirts & Tuxedo Shirts | The Black Tux',
    url_path: '/collections/shirts',
  },
  {
    meta_description:
      'Browse our collection of dress shoes, including a variety of colors and styles to complete your outfit for your wedding or event.',
    page_title: 'Dress Shoes | The Black Tux',
    url_path: '/collections/shoes',
  },
  {
    meta_description:
      'Browse our collection of suits and tuxedos at The Black Tux. Build your look from a variety of styles, or choose from our selection of complete outfits.',
    page_title: 'Browse Suits & Tuxedos | The Black Tux',
    url_path: '/collections/suits-tuxedos',
  },
  {
    meta_description:
      'Explore our tux and suit accessories, including pocket squares, belts, suspenders, and more to put the finishing touch on your outfit.',
    page_title: 'Tuxedo & Suit Accessories | The Black Tux',
    url_path: '/collections/the-rest',
  },
  {
    meta_description:
      'Browse our collection of tuxedo and suit vests to match your suit or tux. Find the perfect look for your wedding, groomsmen, or event.',
    page_title: 'Tuxedo & Suit Vests | The Black Tux',
    url_path: '/collections/vests',
  },
]
/* eslint-enable max-len */

export default seoTags
